import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { CtaButton } from "@/components/site/CtaButton";
import { Seo } from "@/components/Seo";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ARTICLES } from "@/data/articles";

const CATEGORIES = [...new Set(ARTICLES.map((a) => a.category))];

export default function Insights() {
  return (
    <div data-testid="insights-page">
      <Seo
        title="Insights — Short Reads on AI for Small Business | The AI Doctor"
        description="Short, plain-English reads on where AI actually helps a small business: follow-up, admin, pricing your time, and choosing tools that get used."
      />
      <PageHero
        eyebrow="Insights"
        title={<>Short reads. <span className="text-[#5CCBF5]">Real answers.</span></>}
        intro="No hype, no listicles of 47 tools. Just what I keep finding when I examine real businesses — and what actually fixes it. I also film real diagnoses: @theaidoctor on YouTube."
      >
        <Reveal delay={0.24} className="mt-10 flex flex-wrap gap-3">
          {CATEGORIES.map((c) => (
            <span key={c} className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#a7a7a2] border border-white/10 px-4 py-2">{c}</span>
          ))}
        </Reveal>
        <Reveal delay={0.3} className="mt-10">
          <CtaButton to="/apply" testid="insights-cta">Get Your Free AI Check-Up</CtaButton>
        </Reveal>
      </PageHero>

      <section className="shell pb-28 lg:pb-40">
        <div className="border-t border-l border-white/10 grid sm:grid-cols-2">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 2) * 0.06}>
              <Link
                to={`/insights/${a.slug}`}
                data-testid={`insight-card-${i}`}
                className="group block border-r border-b border-white/10 p-8 lg:p-12 h-full hover:bg-[#131C31] transition-colors duration-500"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#5CCBF5]">{a.category}</span>
                  <ArrowUpRight size={18} className="text-[#5c5c58] group-hover:text-[#f5f3ee] transition-colors duration-300" />
                </div>
                <h2 className="display text-2xl lg:text-3xl text-[#f5f3ee] mt-8 leading-tight group-hover:text-[#5CCBF5] transition-colors duration-300">
                  {a.title}
                </h2>
                <p className="mt-4 text-[#a7a7a2] leading-relaxed">{a.excerpt}</p>
                <span className="mt-8 inline-flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] uppercase">
                  <span className="text-[#5CCBF5] group-hover:underline">Open →</span>
                  <span className="text-[#5c5c58]">{a.minutes} min read</span>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
